<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="settingInfo"
            :model='settingInfo'
            label-position="right"
            :label-width="200"
            :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">
          <Col span="24" v-for="other in settingInfo.other" :key="other.setting_id">
            <FormItem :label="other.title+'：'">
              <div v-if="other.sys_config_id === 11 || other.sys_config_id === 12 || other.sys_config_id === 13 || other.sys_config_id === 14">
                <RadioGroup v-model="other.item_value">
                  <Radio :label="1">
                    <span>是</span>
                  </Radio>
                  <Radio :label="0">
                    <span>否</span>
                  </Radio>
                </RadioGroup>
              </div>
              <div v-else>
                <Input
                  v-model="other.item_value"
                  class="perW30"
                />
              </div>

            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Button
            type="primary"
            class="submission"
            @click="handleSubmit('settingInfo')"
          >保存</Button>
        </FormItem>

      </Form>
    </card>

  </div>

</template>
<script>
import { setting, settingUpdate } from '@/api/systemSetting'
export default {
  name: 'systemSetting',
  data () {
    return {
      per: 10,
      settingInfo: {
      },
      ruleValidate: {
      }
    }
  },
  created () {
    this.goodsInfoEdit()
  },
  methods: {
    handleSubmit (name) {
      let other = this.settingInfo.other
      for (const ot in other) {
        if (other[ot].item_value < 0) {
          this.$Message.error('配置项不能小于0')
          return
        }
      }
      settingUpdate(this.settingInfo).then(res => {
        if (res.code === 200) {
          this.$Message.success('修改成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 编辑加载数据
    goodsInfoEdit (id) {
      setting().then(res => {
        console.log(res)
        this.settingInfo = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
